(function(){
  "use strict";

  // Exit if calculator HTML is not on this page
  if (!document.getElementById("ols-formula-calc")) return;

  /* ── DATA ── */
  var AGES = [
    { val:0.25, label:"0\u20132 weeks" },
    { val:0.75, label:"2\u20134 weeks" },
    { val:1.5,  label:"1\u20132 months" },
    { val:3,    label:"2\u20134 months" },
    { val:5,    label:"4\u20136 months" },
    { val:7.5,  label:"6\u20139 months" },
    { val:10.5, label:"9\u201312 months" }
  ];

  var FD = [
    { min:0,   max:0.5, oz:[1.5,3],  f:[8,12], h:[2,3], sol:false, note:"Feed on demand. Baby\u2019s stomach is marble-sized at birth \u2014 small, frequent feeds are normal." },
    { min:0.5, max:1,   oz:[2,3.5],  f:[7,9],  h:[2,3], sol:false, note:"Expect growth spurts around weeks 2\u20133 \u2014 baby may want extra feeds. This is temporary." },
    { min:1,   max:2,   oz:[3,4],    f:[6,8],  h:[3,4], sol:false, note:"Feeding patterns become more predictable. Night feeds are still normal at this age." },
    { min:2,   max:4,   oz:[4,5],    f:[5,7],  h:[3,4], sol:false, note:"Growth spurt around 3 months. Some babies start sleeping longer stretches at night." },
    { min:4,   max:6,   oz:[5,7],    f:[4,6],  h:[4,5], sol:false, note:"Baby may show interest in solid food, but formula remains the primary source of nutrition." },
    { min:6,   max:9,   oz:[6,8],    f:[3,5],  h:[4,6], sol:true,  note:"Introduce solids alongside formula. 24\u201332 oz of formula per day is typical at this age." },
    { min:9,   max:12,  oz:[7,8],    f:[3,4],  h:[4,6], sol:true,  note:"Solid foods increase to 3 meals/day. Formula still provides roughly 50% of daily calories." }
  ];

  var FORMULAS = [
    { name:"HiPP Dutch",  g:800, price:44.45, yld:177, url:"/products/hipp-dutch-stage-1" },
    { name:"HiPP German", g:600, price:34.00, yld:133, url:"/products/hipp-german-stage-1" },
    { name:"HiPP HA",     g:600, price:34.95, yld:133, url:"/products/hipp-ha-stage-1" },
    { name:"Holle Cow",   g:400, price:24.79, yld:90,  url:"/products/holle-bio-stage-1" },
    { name:"Holle Goat",  g:400, price:27.35, yld:90,  url:"/products/holle-dutch-formula" },
    { name:"Kendamil",    g:800, price:43.60, yld:177, url:"/products/kendamil-organic-formula" }
  ];

  /* ── STATE ── */
  var selAge = 0;

  /* ── DOM REFS ── */
  var $ages   = document.getElementById("olsc-ages");
  var $weight = document.getElementById("olsc-weight");
  var $kg     = document.getElementById("olsc-kg");
  var $form   = document.getElementById("olsc-formula");
  var $cta    = document.getElementById("olsc-cta");
  var $res    = document.getElementById("olsc-results");
  var $stats  = document.getElementById("olsc-stats");
  var $tipAge = document.getElementById("olsc-tip-age");
  var $tipRng = document.getElementById("olsc-tip-range");
  var $sched  = document.getElementById("olsc-sched");
  var $tipSol = document.getElementById("olsc-tip-solids");
  var $costs  = document.getElementById("olsc-costs");
  var $cNote  = document.getElementById("olsc-cost-note");

  if (!$ages || !$form || !$cta) return; // safety check

  /* ── BUILD AGE BUTTONS ── */
  AGES.forEach(function(a, i) {
    var btn = document.createElement("button");
    btn.className = "olsc-age-btn" + (i === 0 ? " active" : "");
    btn.textContent = a.label;
    btn.type = "button";
    btn.addEventListener("click", function() {
      selAge = i;
      var btns = $ages.querySelectorAll(".olsc-age-btn");
      for (var j = 0; j < btns.length; j++) {
        btns[j].className = "olsc-age-btn" + (j === i ? " active" : "");
      }
      $res.classList.remove("visible");
    });
    $ages.appendChild(btn);
  });

  /* ── BUILD FORMULA SELECT ── */
  FORMULAS.forEach(function(f, i) {
    var opt = document.createElement("option");
    opt.value = i;
    opt.textContent = f.name + " \u2014 " + f.g + "g \u00B7 $" + f.price.toFixed(2);
    $form.appendChild(opt);
  });

  /* ── WEIGHT KG DISPLAY ── */
  $weight.addEventListener("input", function() {
    var v = parseFloat(this.value);
    $kg.textContent = v ? "(" + (v * 0.4536).toFixed(1) + " kg)" : "";
    $res.classList.remove("visible");
  });

  /* ── HELPERS ── */
  function getData(ageVal) {
    for (var i = FD.length - 1; i >= 0; i--) {
      if (ageVal >= FD[i].min) return FD[i];
    }
    return FD[0];
  }

  function r(n) { return Math.round(n * 10) / 10; }

  function calc() {
    var age = AGES[selAge];
    var d = getData(age.val);
    var avgOz = (d.oz[0] + d.oz[1]) / 2;
    var avgF = Math.round((d.f[0] + d.f[1]) / 2);
    var avgH = (d.h[0] + d.h[1]) / 2;
    var total = avgOz * avgF;
    var wLbs = parseFloat($weight.value);
    if (wLbs && wLbs > 0) {
      var wbT = Math.min(wLbs * 2.5, 32);
      total = Math.round((total + wbT) / 2);
    }
    var ozPer = r(total / avgF);
    var times = [];
    var hour = 7;
    for (var i = 0; i < avgF; i++) {
      var h24 = Math.round(hour) % 24;
      var ampm = h24 < 12 ? "AM" : "PM";
      var h12 = h24 === 0 ? 12 : h24 > 12 ? h24 - 12 : h24;
      times.push({ time: h12 + ":00 " + ampm, oz: ozPer, night: h24 >= 22 || h24 < 6 });
      hour += avgH;
    }
    return { times: times, ozPer: ozPer, feeds: avgF, total: Math.round(total), interval: avgH, data: d, age: age };
  }

  /* ── RENDER RESULTS ── */
  function render(s) {
    $stats.innerHTML =
      '<div class="olsc-stat olsc-stat-light"><div class="olsc-stat-label">Per Feeding</div><div class="olsc-stat-value">' + s.ozPer + ' <span class="olsc-stat-unit">oz</span></div></div>' +
      '<div class="olsc-stat olsc-stat-dark"><div class="olsc-stat-label">Feeds / Day</div><div class="olsc-stat-value">' + s.feeds + '</div></div>' +
      '<div class="olsc-stat olsc-stat-light"><div class="olsc-stat-label">Total / Day</div><div class="olsc-stat-value">' + s.total + ' <span class="olsc-stat-unit">oz</span></div></div>' +
      '<div class="olsc-stat olsc-stat-dark"><div class="olsc-stat-label">Every</div><div class="olsc-stat-value">' + s.interval + ' <span class="olsc-stat-unit">hrs</span></div></div>';

    $tipAge.innerHTML = '<strong>\uD83D\uDCA1 ' + s.age.label + ':</strong> ' + s.data.note;

    var rangeHtml = '<strong>Recommended range:</strong> ' + s.data.oz[0] + '\u2013' + s.data.oz[1] + ' oz per feeding \u00B7 ' + s.data.f[0] + '\u2013' + s.data.f[1] + ' feeds/day \u00B7 Every ' + s.data.h[0] + '\u2013' + s.data.h[1] + ' hours.';
    var wLbs = parseFloat($weight.value);
    if (wLbs > 0) rangeHtml += ' Weight-adjusted estimate included (' + wLbs + ' lbs \u00D7 2.5 oz/lb = ' + Math.min(wLbs * 2.5, 32).toFixed(0) + ' oz/day cap).';
    $tipRng.innerHTML = rangeHtml;

    var sh = '<div class="olsc-sched-hdr"><div class="olsc-sched-hdr-t">Time</div><div class="olsc-sched-hdr-a">Amount</div><div class="olsc-sched-hdr-m">ml</div></div>';
    s.times.forEach(function(t, i) {
      sh += '<div class="olsc-sched-row" style="animation-delay:' + (i * 0.05) + 's">' +
        '<div class="olsc-sched-dot ' + (t.night ? 'olsc-dot-night' : 'olsc-dot-day') + '">' + (t.night ? '\uD83C\uDF19' : '\u2600\uFE0F') + '</div>' +
        '<div class="olsc-sched-info"><div class="olsc-sched-time">' + t.time + '</div><div class="olsc-sched-type">' + (t.night ? 'Night feed' : 'Day feed') + '</div></div>' +
        '<div class="olsc-sched-oz">' + t.oz + ' oz</div>' +
        '<div class="olsc-sched-ml">' + Math.round(t.oz * 29.57) + ' ml</div></div>';
    });
    sh += '<div class="olsc-sched-total"><span>Daily Total</span><span>' + s.total + ' oz (' + Math.round(s.total * 29.57) + ' ml)</span></div>';
    $sched.innerHTML = sh;

    $tipSol.style.display = s.data.sol ? "block" : "none";

    var ch = "";
    FORMULAS.forEach(function(f) {
      var cans = (s.total * 30) / f.yld;
      var mo = Math.round(cans * f.price);
      ch += '<div class="olsc-cost-card">' +
        '<div style="flex:1"><div class="olsc-cost-name">' + f.name + '</div><div class="olsc-cost-meta">' + f.g + 'g \u00B7 $' + f.price.toFixed(2) + '/can \u00B7 ~' + Math.ceil(cans) + ' cans/mo</div></div>' +
        '<div style="text-align:right"><div class="olsc-cost-price">$' + mo + '</div><div class="olsc-cost-per">per month</div></div></div>';
    });
    $costs.innerHTML = ch;
    $cNote.textContent = "Based on " + s.total + " oz/day \u00D7 30 days. Actual usage varies. Prices reflect Organic Life Start multi-can discounts.";

    $res.classList.add("visible");
    setTimeout(function() { $res.scrollIntoView({ behavior: "smooth", block: "start" }); }, 100);
  }

  /* ── CTA CLICK ── */
  $cta.addEventListener("click", function() { render(calc()); });

  /* ── PRINT / PDF ── */
  document.getElementById("olsc-btn-print").addEventListener("click", function() {
    var s = calc();
    var fi = parseInt($form.value);
    var f = FORMULAS[fi];
    var wLbs = parseFloat($weight.value);
    var costLine = "$" + Math.round((s.total * 30) / f.yld * f.price) + " /mo (" + f.name + ")";

    var rows = s.times.map(function(t) {
      return '<tr><td style="padding:8px 12px;border-bottom:1px solid #ddd;font-weight:600">' + t.time + '</td><td style="padding:8px 12px;border-bottom:1px solid #ddd">' + t.oz + ' oz (' + Math.round(t.oz * 29.57) + ' ml)</td><td style="padding:8px 12px;border-bottom:1px solid #ddd">' + (t.night ? '\uD83C\uDF19 Night' : '\u2600\uFE0F Day') + ' feed</td></tr>';
    }).join("");

    var html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Formula Feeding Schedule</title>' +
      '<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Georgia,serif;color:#1a1a1a;padding:40px;max-width:700px;margin:0 auto}h1{font-size:22px;color:#1b4332;margin-bottom:4px}h2{font-size:16px;color:#2d6a4f;margin:20px 0 8px;border-bottom:2px solid #2d6a4f;padding-bottom:4px}.meta{color:#666;font-size:13px;margin-bottom:20px}.box{background:#f0f7f0;border-left:4px solid #2d6a4f;padding:12px 16px;margin:16px 0;font-size:14px;line-height:1.6}table{width:100%;border-collapse:collapse;margin:12px 0}th{background:#2d6a4f;color:#fff;padding:8px 12px;text-align:left;font-size:13px}td{font-size:13px}.s{display:inline-block;background:#e8f3e8;padding:6px 12px;border-radius:4px;margin:4px;font-size:13px}.ft{margin-top:24px;padding-top:12px;border-top:1px solid #ddd;font-size:11px;color:#888;text-align:center}@media print{body{padding:20px}}</style></head><body>' +
      '<h1>\uD83C\uDF7C My Baby\'s Formula Feeding Schedule</h1>' +
      '<p class="meta">Age: ' + s.age.label + (wLbs ? ' \u00B7 Weight: ' + wLbs + ' lbs' : '') + ' \u00B7 Generated on ' + new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) + '</p>' +
      '<div class="box"><strong>Daily Summary</strong><br><span class="s">Per feeding: ' + s.ozPer + ' oz</span><span class="s">Feeds/day: ' + s.feeds + '</span><span class="s">Total/day: ' + s.total + ' oz</span><span class="s">Every ' + s.interval + ' hrs</span><br><span class="s">' + costLine + '</span></div>' +
      '<h2>Daily Schedule</h2><table><thead><tr><th>Time</th><th>Amount</th><th>Note</th></tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div class="box">\uD83D\uDCA1 <strong>Tip:</strong> ' + s.data.note + '</div>' +
      (s.data.sol ? '<div class="box">\uD83E\uDD44 <strong>Solids:</strong> Introduce 2\u20133 small solid meals alongside formula. Start with pur\u00E9es and soft textures. Formula still provides the majority of calories.</div>' : '') +
      '<h2>Recommended Range</h2><p style="font-size:13px;line-height:1.6">Per feeding: ' + s.data.oz[0] + '\u2013' + s.data.oz[1] + ' oz \u00B7 Feeds per day: ' + s.data.f[0] + '\u2013' + s.data.f[1] + ' \u00B7 Interval: every ' + s.data.h[0] + '\u2013' + s.data.h[1] + ' hours. Always follow your baby\'s hunger cues and your pediatrician\'s advice.</p>' +
      '<div class="ft">Generated by Organic Life Start Formula Calculator \u00B7 organiclifestart.com<br>This is a general guide, not medical advice.</div></body></html>';

    var blob = new Blob([html], { type: "text/html" });
    var url = URL.createObjectURL(blob);
    var win = window.open(url, "_blank");
    if (win) {
      win.onload = function() { setTimeout(function() { win.print(); }, 500); };
    }
    setTimeout(function() { URL.revokeObjectURL(url); }, 15000);
  });

  /* ── SHARE ── */
  document.getElementById("olsc-btn-share").addEventListener("click", function() {
    var s = calc();
    var txt = "My baby's formula schedule (" + s.age.label + "):\n" +
      s.times.map(function(t) { return t.time + ": " + t.oz + " oz"; }).join("\n") +
      "\nTotal: " + s.total + " oz/day\n\nCalculated at organiclifestart.com";
    if (navigator.share) {
      navigator.share({ title: "Formula Feeding Schedule", text: txt }).catch(function() {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(txt).then(function() {
        var btn = document.getElementById("olsc-btn-share");
        var orig = btn.innerHTML;
        btn.innerHTML = "\u2705 Copied!";
        setTimeout(function() { btn.innerHTML = orig; }, 2000);
      });
    } else {
      window.prompt("Copy this schedule:", txt);
    }
  });

})();